import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import StyleModulePopup from './StyleModulePopup';

const Popup = (props) => {
    console.log(90,props)
    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            

            <Modal show={props.flag} onHide={()=>props.setFlag()}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Style</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StyleModulePopup onHide={() => props.setFlag()} />
                </Modal.Body>
              
            </Modal>
        </>
    );
}

export default Popup;